import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalVariable } from 'app/main/globals';

@Injectable({
  providedIn: 'root'
})
export class AspHelpUsImproveService {

  constructor(private http: HttpClient) { }

  getFeedbackOptions() {
    return this.http.get<any>( `${GlobalVariable.BASE_API_URL_SPARES}/customer/rating/customerfeedback`  );
  }
  submitFeedback(feedbackPayload: any) {
    return this.http.post( `${GlobalVariable.BASE_API_URL_SPARES}/customer/feedback`,  feedbackPayload );
  }
}
